import * as React from 'react';
import * as mui from '@mui/material';
import ProductsAccordions from './ProductsAccordions';

export default function Step3() {
	React.useEffect(() => {
		window.scroll({ top: 0, left: 0 });
	}, []);

	return (
		<mui.Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
			<ProductsAccordions />
		</mui.Box>
	);
}
